import React, { useState } from 'react';
import { Modal, Toast } from 'react-bootstrap';
import { Controller } from "react-hook-form";
import Select from 'react-select';
import Api from '../../../Auth/Api';
import { decodeJWT } from '../../jwtUtils';

const AddUsuarioModal = ({
	showModalAddUsuario,
	setShowModalAddUsuario,
	dataCargos,
	dataUnidades,
	dataGestores,
	dataEmpresas,
	dataCursos,
	customStyles,
	nivel,
	register,
	control,
	errors,
	handleSubmit,
	onSubmitAddParticipante,
	loadingSaveUser,
	selectCursos,
	setSelectCursos
}) => {
	const [showGestorResponsavel, setShowGestorResponsavel] = useState(false);
	const [showEmpresa, setShowEmpresa] = useState(false);
	const [toast, setToast] = useState({});
	const [showToast, setShowToast] = useState(false);

	const token = JSON.parse(localStorage.getItem("user_token"));
	const usuarioId = decodeJWT(token).idUsuario;
	const usuarioNome = decodeJWT(token).nomeCompleto;
	
	const getDataNiveis = (nivel) => {
		switch (nivel) {
			case 'Administrador':
				return [
					{ value: 'Aluno', label: 'Aluno' },
					{ value: 'Gestor', label: 'Gestor' },
					{ value: 'Administrador', label: 'Administrador' },
					{ value: 'Moderador', label: 'Moderador' }
				];
			case 'Gestor':
				return [
					{ value: 'Aluno', label: 'Aluno' },
				];
			case 'Moderador':
				return [
					{ value: 'Aluno', label: 'Aluno' },
					{ value: 'Gestor', label: 'Gestor' },
				];
			default:
				return [];
		}
	};

	const dataNiveis = getDataNiveis(nivel);

	// Função para buscar empresa do gestor selecionado
	const buscarEmpresaGestor = async (gestorId) => {
		try {
			const response = await Api.get(`/api/usuario/${gestorId}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			
			if (response.data && response.data.empresa_id) {
				// Buscar dados completos da empresa
				const empresaResponse = await Api.get(`/api/empresa/${response.data.empresa_id}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				});
				
				if (empresaResponse.data) {
					return {
						value: empresaResponse.data.id,
						label: empresaResponse.data.titulo
					};
				}
			}
			return null;
		} catch (error) {
			console.error("Erro ao buscar empresa do gestor:", error);
			return null;
		}
	};

	// Função para mostrar mensagens de toast
	const showToastMessage = (header, body, variant = 'light') => {
		setToast({ header, body, variant });
		setShowToast(true);
	};

	const onSubmit = async (data) => {
		// Se o nível selecionado for Aluno
		if (data.nivel?.value === 'Aluno') {
			// Se o usuário logado for Gestor e não tiver selecionado gestor responsável
			if (nivel === 'Gestor' && !data.gestor_responsavel) {
				data.gestor_responsavel = {
					value: usuarioId,
					label: usuarioNome
				};
			}
			
			// Para alunos, buscar a empresa do gestor responsável
			if (data.gestor_responsavel) {
				const empresaGestor = await buscarEmpresaGestor(data.gestor_responsavel.value);
				if (empresaGestor) {
					data.empresa = empresaGestor;
				}
			}
		} else {
			// Para outros níveis, remover gestor responsável caso tenha sido selecionado
			delete data.gestor_responsavel;
		}
		
		const result = await onSubmitAddParticipante(data);
		
		if (result && result.success) {
			showToastMessage('Sucesso!', result.message, 'success');
			setShowModalAddUsuario(false);
		} else if (result) {
			showToastMessage('Erro!', result.message, 'danger');
		}
	};

	return (
		<>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={5000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

			<Modal size="lg" show={showModalAddUsuario} onHide={() => setShowModalAddUsuario(false)}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<Modal.Header closeButton>
						<span className="fw-semibold fs-4 text-primary"> Adicionar Usuário </span>
					</Modal.Header>
					<Modal.Body>
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="body">
										<div className="d-flex">
											<div className="d-flex flex-column w-100">
												<div className="row mb-3">
													<div className="col-12 col-md-8">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Nome</label>
															<input
																type="text"
																{...register("nome_completo", { required: true })}
																placeholder="Nome do usuário"
																className="form-control border-primary"
															/>
															{errors.nome_completo && <span className='text-danger fs-7'>Nome completo é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12 col-md-4">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Matrícula</label>
															<input
																type="number"
																{...register("codigo", { required: true })}
																placeholder="Digite a matrícula"
																className="form-control border-primary"
															/>
															{errors.codigo && <span className='text-danger fs-7'>Matrícula é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Email</label>
															<input
																type="email"
																{...register("email", { required: true })}
																placeholder="email@email.com"
																className="form-control border-primary"
															/>
															{errors.email && <span className='text-danger fs-7'>Email é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12 col-md-6">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Cargo</label>
															<Controller
																name="cargo"
																control={control}
																defaultValue={[]}
																rules={{ required: true }}
																render={({ field }) => (
																	<Select
																		{...field}
																		options={dataCargos}
																		value={field.value}
																		styles={customStyles}
																		placeholder="Selecione um cargo"
																		noOptionsMessage={() => "Nenhum cargo encontrado."}
																	/>
																)}
															/>
															{errors.cargo && <span className='text-danger fs-7'>Cargo é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12 col-md-6">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Tipo Usuário</label>
															<Controller
																name="nivel"
																control={control}
																defaultValue={[]}
																rules={{ required: true }}
																render={({ field }) => (
																	<Select
																		{...field}
																		options={dataNiveis}
																		value={field.value}
																		styles={customStyles}
																		onChange={value => {
																			// Lógica para mostrar campos baseado no tipo de usuário
																			if (value.value === 'Aluno') {
																				setSelectCursos(true);
																				setShowGestorResponsavel(true);
																				setShowEmpresa(false); // Aluno não seleciona empresa diretamente
																			} else if (value.value === 'Gestor') {
																				setSelectCursos(false);
																				setShowGestorResponsavel(false);
																				setShowEmpresa(true); // Gestor seleciona empresa
																			} else if (value.value === 'Administrador' || value.value === 'Moderador') {
																				setSelectCursos(false);
																				setShowGestorResponsavel(false);
																				setShowEmpresa(false); // Admin e Moderador não selecionam empresa
																			}
																			field.onChange(value);
																		}}
																		placeholder="Selecione tipo do usuário"
																		noOptionsMessage={() => "Nenhum tipo de usuário encontrado."}
																	/>
																)}
															/>
															{errors.nivel && <span className='text-danger fs-7'>Tipo de usuário é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12 col-md-6">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Unidade</label>
															<Controller
																name="unidade"
																control={control}
																defaultValue={[]}
																rules={{ required: true }}
																render={({ field }) => (
																	<Select
																		{...field}
																		options={
																			dataUnidades.map((value) => ({
																				value: value.label,
																				label: `${value.label}`,
																			}))
																		}
																		value={field.value}
																		styles={customStyles}
																		onChange={value => field.onChange(value)}
																		placeholder="Selecione uma unidade"
																		noOptionsMessage={() => "Nenhuma unidade encontrada."}
																	/>
																)}
															/>
															{errors.unidade && <span className='text-danger fs-7'>Selecione uma unidade.</span>}
														</div>
													</div>

													{/* Campo de Empresa - apenas para Gestor */}
													{showEmpresa && (
														<div className="col-12 col-md-6">
															<div className="mb-3">
																<label className="form-label text-primary fw-medium">Empresa</label>
																<Controller
																	name="empresa"
																	control={control}
																	defaultValue={null}
																	rules={{ required: showEmpresa }}
																	render={({ field }) => (
																		<Select
																			{...field}
																			options={dataEmpresas}
																			value={field.value}
																			styles={customStyles}
																			onChange={value => field.onChange(value)}
																			placeholder="Selecione uma empresa"
																			noOptionsMessage={() => "Nenhuma empresa encontrada."}
																			isClearable
																		/>
																	)}
																/>
																{errors.empresa && <span className='text-danger fs-7'>Empresa é obrigatória para Gestor.</span>}
															</div>
														</div>
													)}

													{/* Campo de Gestor Responsável - apenas para Aluno */}
													{showGestorResponsavel && (
														<div className="col-12 col-md-6">
															<div className="mb-3">
																<label className="form-label text-primary fw-medium">Gestor Responsável</label>
																<Controller
																	name="gestor_responsavel"
																	control={control}
																	defaultValue={nivel === 'Gestor' ? {
																		value: usuarioId,
																		label: usuarioNome
																	} : null}
																	rules={{ required: showGestorResponsavel }}
																	render={({ field }) => (
																		<Select
																			{...field}
																			options={dataGestores}
																			value={field.value}
																			styles={customStyles}
																			onChange={async (value) => {
																				field.onChange(value);
																				
																				// Buscar empresa do gestor selecionado
																				if (value) {
																					const empresaGestor = await buscarEmpresaGestor(value.value);
																					if (empresaGestor) {
																						// Mostrar informação sobre a empresa que será herdada
																						showToastMessage(
																							'Empresa Selecionada', 
																							`O aluno será vinculado à empresa: ${empresaGestor.label}`, 
																							'light'
																						);
																					}
																				}
																			}}
																			placeholder="Selecione o gestor responsável"
																			noOptionsMessage={() => "Nenhum gestor encontrado."}
																			isDisabled={nivel === 'Gestor'}
																		/>
																	)}
																/>
																{errors.gestor_responsavel && <span className='text-danger fs-7'>Gestor responsável é obrigatório.</span>}
																{showGestorResponsavel && (
																	<small className="text-muted">
																		A empresa será automaticamente definida com base no gestor selecionado.
																	</small>
																)}
															</div>
														</div>
													)}

													{/* Campo de Gestor Responsável para Moderador */}
													{nivel === 'Moderador' && (
														<div className="col-12 col-md-6">
															<div className="mb-3">
																<label className="form-label text-primary fw-medium">Gestor Responsável</label>
																<Controller
																	name="gestor_responsavel"
																	control={control}
																	defaultValue={null}
																	render={({ field }) => (
																		<Select
																			{...field}
																			options={dataGestores}
																			value={field.value}
																			styles={customStyles}
																			onChange={value => field.onChange(value)}
																			placeholder="Selecione o gestor responsável"
																			noOptionsMessage={() => "Nenhum gestor encontrado."}
																			isClearable
																		/>
																	)}
																/>
																<small className="text-muted">Campo opcional</small>
															</div>
														</div>
													)}

													{selectCursos && (
														<div className="col-12 col-md-12">
															<div className="mb-3">
																<label className="form-label text-primary fw-medium">Cursos</label>
																<Controller
																	name="cursos"
																	control={control}
																	defaultValue={[]}
																	rules={{ required: true }}
																	render={({ field }) => (
																		<Select
																			{...field}
																			isMulti
																			options={dataCursos.map((value) => ({
																				value: value.id,
																				label: `${value.nome}`,
																			}))}
																			value={field.value}
																			styles={customStyles}
																			onChange={value => field.onChange(value)}
																			noOptionsMessage={() => "Nenhum curso encontrado."}
																			placeholder="Selecione os cursos"
																		/>
																	)}
																/>
																{errors.cursos && <span className='text-danger fs-7'>Selecione pelo menos um curso.</span>}
															</div>
														</div>
													)}

													<div className="col-12 col-md-6">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Senha</label>
															<input 
																type="password" 
																{...register("senha", { required: true })} 
																placeholder="********" 
																className="form-control border-primary" 
															/>
															{errors.senha && <span className='text-danger fs-7'>Senha é obrigatória.</span>}
														</div>
													</div>

													<div className="col-12 col-md-6">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Confirme a senha</label>
															<input 
																type="password" 
																{...register("confirme_senha", { required: true })} 
																placeholder="********" 
																className="form-control border-primary" 
															/>
															{errors.confirme_senha && <span className='text-danger fs-7'>Confirme a senha.</span>}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button
							type="submit"
							className="btn btn-primary text-white"
							disabled={loadingSaveUser}
						>
							{loadingSaveUser ? 'Salvando...' : 'Salvar'}
						</button>
						<button
							type="button"
							className="btn btn-outline-primary text-primary"
							onClick={() => setShowModalAddUsuario(false)}
						>
							Cancelar
						</button>
					</Modal.Footer>
				</form>
			</Modal>
		</>
	);
};

export default AddUsuarioModal; 